import { callScheduleSync } from './actions/call-schedule-sync.js'
import { callCheckUpToDate } from './actions/check-uptodate.js'
import { callCheckVsXeroPnl } from './actions/check-vs-xero-pnl.js'

export function addListeners (gridApi, containerElement, context) {
  containerElement.addEventListener('click', async (event) => {
    console.log('click', event)

    const targetButton = event.target.closest('button[data-action]')
    if (!targetButton) return

    const action = targetButton.getAttribute('data-action')
    const entityId = targetButton.getAttribute('data-entity-id')

    refreshCell(gridApi, entityId, action, true)

    if (action === 'refresh-asap') {
      await callScheduleSync(gridApi, entityId)
    } else if (action === 'check-data') {
      await callCheckVsXeroPnl(gridApi, entityId)
    } else if (action === 'check-uptodate') {
      await callCheckUpToDate(gridApi, entityId)
    }

    refreshCell(gridApi, entityId, action, false)
  })
}

function refreshCell (gridApi, entityId, action, isLoading) {
  const gridRowNode = gridApi.getRowNode(entityId)
  gridRowNode.data.ongoingAction = isLoading ? action : null
  gridApi.refreshCells({
    rowNodes: [gridRowNode],
    force: true
  })
}
